export default __webpack_public_path__ + "static/media/button_deposit.2c00b4f3.svg";